module.exports = __webpack_public_path__ + "catalog/items/bathroom/Fancy-toilet/Fancy-toilet.svg";